export default "__VITE_ASSET__CZ8Ro4k4__"